export const GIFT_PRODUCT_TYPES = {
  MEDIUM: 'medium',
  BIG: 'big',
  BIG_DETAILS: 'bigDetails',
  MOBILE_DETAILS: 'mobileDetails',
  LIST: 'list',
  MINIMALIST: 'minimalist'
};

export const MODES = {
  GUEST: 'guest',
  EDIT: 'edit',
};
